exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-696d2b30]{cursor:not-allowed;background:grey;border:none}", ""]);

// exports
